

const logistics_section1_data = [
  {
    title : "Performance & Stability",
    subTitle: "성능 & 안전성",
    desc: ["다양한 판매채널 통합 관리 및 브랜드 운영사례", "대용량 주문 안정적 처리 : 10만건 주문 접수처리시 약 1분 소요"]
  },
  {
    title : "User-Friendly UI",
    subTitle: "사용자 친화적인 UI",
    desc: ["사용자 편의 중심의 인터페이스", "직관적 화면 디자인 및 기능 배치의 단순화"]
  },
  {
    title : "Easy to Work",
    subTitle: "다양성 & 편리성",
    desc: ["간편한 주문처리 작업 (상품매핑, 사은품추가 관리, 세트상품 구성)", "간편하고 다양한 플랫폼 추가 기능"]
  },
  {
    title : "User-Account Management",
    subTitle: "다양화 & 안전성",
    desc: ["Hierarchy 구조의 계정관리로 운영의 다양화", "권한별 운영을 통한 업무 관리 안정성 확보"]
  },
  {
    title : "System Interface",
    subTitle: "연동 & 확정성",
    desc: ["PLATFORM, WMS 연동", "API 기반 운영 확장성"]
  },
];



const logistics_section2_data = [
  {
    title : "다양한 판매채널 통합관리",
    subTitle: "TOTAL CROSSBOARDER SOLUTION",
    desc: "다양한 판매채널 통합관리, 대용량 주문도 안전하게 관리",
    imgs: {
      pc: 'img-19-02-01-pc',
      mo: 'img-19-02-01-mo'
    }
  },
  {
    title : "통관 ⋅ 배송 이슈검증",
    subTitle: "Customs/Delivery Issues",
    desc: "사전 통관, 배송이슈 검증을 통한 배송지연 방지",
    imgs: {
        pc: 'img-19-02-02-pc',
        mo: 'img-19-02-02-mo'
      }
  },
  {
    title : "상세한 주문처리 로그",
    subTitle: "Order Processing Log",
    desc: "주문 ⋅ 배송 과정의 이슈를 로그로 남겨 오배송 최소화",
    imgs: {
      pc: 'img-19-02-03-pc',
      mo: 'img-19-02-03-mo'
    }
  }
];

const logistics_section3_data = [
  {
    title : "계정관리",
    subTitle: "관리자 계정관리, 고객사 계정관리",
  },
  {
    title : "상품관리 (Active)",
    subTitle: "상품마스터관리, 판매상품관리",
  },
  {
    title : "주문관리",
    subTitle: "주문리스트, 출고지시리스트, 이벤트관리",
  },
  {
    title : "출고관리",
    subTitle: "운송장채번, 팔레트관리, 마스터콘솔관리",
  },
  {
    title : "통관관리",
    subTitle: "매니페스트, 수출신고 현황",
  },
  {
    title : "CS관리",
    subTitle: "공지사항",
  },
  {
    title : "기준정보관리",
    subTitle: "기준통화관리,HS CODE 관리,수출신고관리",
  },
  {
    title : "연동관리",
    subTitle: "시스템 연동관리",
  },
];

const logistics_section4_amazon_data = {
  badge: "Amazon SP-API Certified",
  titleEn: "D2C Direct-to-Consumer Solution",
  title: "Amazon D2C\n소비자 직배송 솔루션",
  subtitle: "SP-API 액세스 후 90일 이내 서비스 시작 준비 완료",
  description: "Commerceon OMS는 Amazon SP-API와 연동하여 D2C(Direct-to-Consumer) 주문을 자동으로 수집하고, WMS/물류업체를 통해 소비자에게 직접 배송하는 전 과정을 통합 관리합니다.",
  features: [
    {
      icon: "📦",
      titleEn: "Automated Order Collection",
      title: "주문 자동 수집",
      desc: "Amazon, Rakuten, Qoo10, Shopify 등 다양한 마켓플레이스에서 주문을 실시간으로 수집·정규화"
    },
    {
      icon: "🚚",
      titleEn: "D2C Shipping Automation",
      title: "D2C 배송 자동화",
      desc: "WMS·물류업체에 배송 요청을 자동 전송하고, 운송장 번호를 마켓플레이스에 자동 업데이트"
    },
    {
      icon: "🔒",
      titleEn: "PII Data Protection",
      title: "개인정보(PII) 보호",
      desc: "AES-256 암호화 + 코드 레벨 마스킹으로 배송 이행 목적 외 PII 일절 사용 금지"
    },
    {
      icon: "📊",
      titleEn: "Integrated Order Tracking",
      title: "통합 주문 추적",
      desc: "주문부터 배송완료까지 상세 로그 기록으로 오배송 최소화 및 고객 만족도 향상"
    }
  ],
  process: [
    { step: "01", labelEn: "Order Collection", label: "주문 수집", detail: "마켓플레이스 → OMS" },
    { step: "02", labelEn: "Data Normalization", label: "데이터 정규화", detail: "주문 통합 처리" },
    { step: "03", labelEn: "Shipping Request", label: "배송 요청", detail: "WMS / 물류업체" },
    { step: "04", labelEn: "Tracking Update", label: "운송장 업데이트", detail: "마켓플레이스 반영" }
  ]
};

const logistics_section5_pricing_data = {
  title: "요금 안내",
  subtitle: "Pricing",
  description: "Commerceon OMS 플랫폼은 무료로 제공되며,\n실제 사용하는 물류·WMS 서비스에 대해서만 별도 수수료가 부과됩니다.",
  plans: [
    {
      nameEn: "OMS Platform",
      name: "OMS 플랫폼",
      price: "무료",
      priceDetail: "Free",
      highlight: true,
      features: [
        "주문 수집 및 정규화",
        "다채널 통합 관리 (Amazon, Rakuten, Qoo10, Shopify 등)",
        "주문 처리 로그 및 대시보드",
        "SP-API 연동 (D2C 배송 포함)",
        "계정·권한 관리",
        "기술 지원"
      ]
    },
    {
      nameEn: "Logistics / WMS Integration",
      name: "물류 / WMS 연동",
      price: "별도 협의",
      priceDetail: "Per Usage",
      highlight: false,
      features: [
        "WMS 연동 수수료 (건당 또는 월정액)",
        "물류업체 배송 수수료",
        "통관 및 해외배송 처리 비용",
        "추가 마켓플레이스 연동 (옵션)",
        "전담 운영 지원 (엔터프라이즈)"
      ]
    }
  ],
  note: "* 정확한 수수료는 사용하시는 물류사 및 WMS 업체에 따라 상이하며, 담당자와 협의 후 결정됩니다."
};

export {
  logistics_section1_data,
  logistics_section2_data,
  logistics_section3_data,
  logistics_section4_amazon_data,
  logistics_section5_pricing_data
};

